module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-dark-blue-020-1200x2490.e9cfc198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-dark-blue-020-1200x2490.jpg
// module id = 1106
// module chunks = 37